
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as indexWjcYekRvlv0_6cg6Y4XmaQ2C4J_e2o0I_sIE3P2F6v4Meta } from "/vercel/path0/pages/hobbies/index.vue?macro=true";
import { default as indexbp_45ir4ArCk_evWl23_Ash200A_zE4HOMg2BxNtOxPhkMeta } from "/vercel/path0/pages/projects/index.vue?macro=true";
import { default as indexosb7iz81EZDaLeKeQXb5_HUncvITnqNy1fvALgDH__kMeta } from "/vercel/path0/pages/experiences/index.vue?macro=true";
import { default as _91_46_46_46slug_93Glz67yws0F1tMH44vsRrxymfm_45TT9DR7TY65nw5oGrYMeta } from "/vercel/path0/pages/hobbies/[...slug].vue?macro=true";
import { default as index047GMBuUIDCOjIPTaflAPbw8h28JS8_45IEVp62u8mGwgMeta } from "/vercel/path0/pages/publications/index.vue?macro=true";
import { default as _91_46_46_46slug_933BNl_45sIawlPkzGJkh7ZehuPkyIiC5FybdKdXbHiRGFgMeta } from "/vercel/path0/pages/publications/[...slug].vue?macro=true";
export default [
  {
    name: "index___it",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "hobbies___it",
    path: "/hobbies",
    component: () => import("/vercel/path0/pages/hobbies/index.vue")
  },
  {
    name: "hobbies___en",
    path: "/en/hobbies",
    component: () => import("/vercel/path0/pages/hobbies/index.vue")
  },
  {
    name: "hobbies___es",
    path: "/es/hobbies",
    component: () => import("/vercel/path0/pages/hobbies/index.vue")
  },
  {
    name: "projects___it",
    path: "/projects",
    component: () => import("/vercel/path0/pages/projects/index.vue")
  },
  {
    name: "projects___en",
    path: "/en/projects",
    component: () => import("/vercel/path0/pages/projects/index.vue")
  },
  {
    name: "projects___es",
    path: "/es/projects",
    component: () => import("/vercel/path0/pages/projects/index.vue")
  },
  {
    name: "experiences___it",
    path: "/experiences",
    component: () => import("/vercel/path0/pages/experiences/index.vue")
  },
  {
    name: "experiences___en",
    path: "/en/experiences",
    component: () => import("/vercel/path0/pages/experiences/index.vue")
  },
  {
    name: "experiences___es",
    path: "/es/experiences",
    component: () => import("/vercel/path0/pages/experiences/index.vue")
  },
  {
    name: "hobbies-slug___it",
    path: "/hobbies/:slug(.*)*",
    component: () => import("/vercel/path0/pages/hobbies/[...slug].vue")
  },
  {
    name: "hobbies-slug___en",
    path: "/en/hobbies/:slug(.*)*",
    component: () => import("/vercel/path0/pages/hobbies/[...slug].vue")
  },
  {
    name: "hobbies-slug___es",
    path: "/es/hobbies/:slug(.*)*",
    component: () => import("/vercel/path0/pages/hobbies/[...slug].vue")
  },
  {
    name: "publications___it",
    path: "/publications",
    component: () => import("/vercel/path0/pages/publications/index.vue")
  },
  {
    name: "publications___en",
    path: "/en/publications",
    component: () => import("/vercel/path0/pages/publications/index.vue")
  },
  {
    name: "publications-slug___it",
    path: "/publications/:slug(.*)*",
    component: () => import("/vercel/path0/pages/publications/[...slug].vue")
  },
  {
    name: "publications-slug___en",
    path: "/en/publications/:slug(.*)*",
    component: () => import("/vercel/path0/pages/publications/[...slug].vue")
  }
]